exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n  font-family: Arial, sans-serif;\r\n  margin: 0;\r\n  background-color: #f4f4f4;\r\n  overflow-y: scroll;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader?{"ident":"postcss"}!./src/app/common/styles/init.scss
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/index.js?{"ident":"postcss"}!./src/app/common/styles/init.scss
// module chunks = styles